import React, { useState, useCallback } from 'react'

const StepContext = React.createContext({
  puedeAvanzar: false,
  setPuedeAvanzar: function (e) {
    this.puedeAvanzar = e
  },
  callbackAvance: function (e) {
    console.log('NADA')
  },
  setCallback: function (e) {
    this.callbackAvance = e
  }
})

const StepProvider = (props) => {
  const [puedeAvanzar, setPuedeAvanzar] = useState(false)
  const [callbackAvance, setCallbackAvance] = useState(() => (e) => void e)

  const setCallback = useCallback(
    (callback) => {
      setCallbackAvance(() => () => callback())
    },
    [setCallbackAvance]
  )

  return (
    <StepContext.Provider
      value={{ puedeAvanzar, setPuedeAvanzar, callbackAvance, setCallback }}
    >
      {props.children}
    </StepContext.Provider>
  )
}

export { StepContext, StepProvider }
